import { Component } from '@angular/core';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast-wrapper',
  templateUrl: './toast-wrapper.component.html',
  styleUrl: './toast-wrapper.component.scss',
})
export class ToastWrapperComponent {
  constructor(private toastService: ToastService) {}

  get toasts() {
    return this.toastService.currentToasts;
  }
}
